import React, { useState, useEffect } from 'react'
import langTranslate from 'locale'
// import homeDeal from 'assets/logos/bbd.png'
import { getCookie, getScript, getExtension } from 'utils/browserHelper'
import { isFlightsPage } from 'utils/utmHelper'
import AwesomeSlider from 'react-awesome-slider'
import CoreStyles from 'react-awesome-slider/src/core/styles.scss'
import { ORIGIN_DOMAIN } from 'constants/base'
import { isFeatureEnabled } from 'utils/uiHelper'
import { dataLayerGA } from 'utils/dataLayerHelper.js'
const HomeOffer = ({searchParams}) => {
    const [getOfferList, setOfferList] = useState([])
    const { crousalHeader = {} } = isFeatureEnabled()
    function getOfferUrl(domain) {
        let url = ''
        switch (domain) {
            case 'www.cleartrip.ae':
            case 'qa2.cleartrip.ae':
            case 'me.cleartrip.ae':
            case 'www.cleartrip.ae':
                url = '/offers/uae'
                break
            case 'www.cleartrip.sa':
            case 'qa2.cleartrip.sa':
            case 'me.cleartrip.sa':
            case 'www.cleartrip.sa':
                url = '/offers/saudi-arabia'
                break;
            case 'bh.cleartrip.com':
            case 'bh.cleartrip.sa':
            case 'www.cleartrip.bh':
            case 'www.cleartrip.bh':
                url = '/offers/bahrain'
                break;
            case 'om.cleartrip.com':
            case 'om.cleartrip.sa':
            case 'www.cleartrip.om':
            case 'www.cleartrip.om':
                url = '/offers/oman'
                break;
            case 'kw.cleartrip.com':
            case 'kw.cleartrip.sa':
            case 'www.cleartrip.com.kw':
            case 'www.cleartrip.kw':
                url = '/offers/kuwait'
                break;
            case 'qa.cleartrip.com':
            case 'qar.cleartrip.sa':
            case 'www.cleartrip.qa':
            case 'www.cleartrip.qa':
                url = '/offers/qatar'
                break;
            default:
                url = '/offers/uae'
        }
        return url
    }
    const offerUrl = getOfferUrl(window.location.hostname)
    useEffect(() => {
        injectCarausalOffer()
    }, [])

    let flightPage = isFlightsPage()
    const injectCarausalOffer = async () => {
        try {
            let urlPath = flightPage ? 'Air' : 'Home'
            const URL = `${ORIGIN_DOMAIN}/offer-carousel/air/B2C${urlPath}_${getExtension()}.js?${new Date().getTime()}`
            getScript(URL, function() {
                let offerJson = eval(window.home_offers.offers || window.home_offers)
                'ar' == getCookie('lp') &&
                    offerJson.forEach(function(e) {
                        ;(e.DESC1 = e.DESC1_AR || e.DESC1),
                            (e.HEADING = e.HEADING_AR || e.HEADING),
                            (e.TITLE = e.TITLE_AR || e.TITLE)
                    }),
                    setOfferList(offerJson)
            })
        } catch (e) {
            console.log('fetch offer api error', e)
        }
    }

    const handleClick = event => {
        dataLayerGA({ clicked_option_name: event,section: 'Flights' ,flight_type:searchParams?.intl==='y' ? 'International' : 'Domestic'}, 'offer_know_more_click')
    }
    useEffect(() => {
        let custom = 3
        if(getOfferList.length>0){
         custom = getOfferList.length
        }
        document.documentElement.style.setProperty('--arrow-offer-value', `${(153-((custom-1)*11+17))/2}px`);
    }, [getOfferList])
    return (
        <>
           
            {getOfferList && getOfferList.length > 0 && (
                <>
                 <div class="flex flex-between flex-middle mb-4 mt-6">
                 <div class="flex flex-column">
                     <p class="fs-5 fw-600 c-neutral-900">More offers</p>
                  </div>
                  <div class="flex flex-column">
                  <a
                              href={offerUrl}
                              target="_blank"
                              className="c-secondary-500 fs-14 fw-600 td-none hover:td-underline"
                          >
                              {langTranslate('View all')}
                      </a>
                      {/* <p class="fs-4 fw-600 c-neutral-900">Round trip</p> */}
                  </div>
                      
              </div>
                <div className="ba bc-neutral-100 br-8 pt-6 pb-6">
                    
                    <AwesomeSlider 
                    cssModule={CoreStyles} 
                    bullets={true}
                    buttonContentLeft={<svg width="6" height="10" viewBox="0 0 6 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M5 9L1 5L5 1" stroke="#808080" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>                    
                    }
                    buttonContentRight={<svg width="6" height="10" viewBox="0 0 6 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M1 9L5 5L1 1" stroke="#808080" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                    
                    }
                    organicArrows={false}
                    >
                        {getOfferList.map(item => (
                            <div class="flex flex-middle flex-between">
                                <p  className="c-neutral-900 fs-4 fw-600 mb-1 px-6 td-none">
                                {item.HEADING}
                                </p>
                                {item.TITLE && <p className="fs-3 px-6 c-neutral-900 fw-500 mb-2 mt-4">{item.TITLE}</p>}
                                {item.DESC1 && <p className="fs-3 px-6 c-neutral-900 fw-400">{item.DESC1}</p>}
                                <a
                                    onClick={() => handleClick(item.HEADING)}
                                    href={item.LINK1}
                                    target="_blank"
                                    className="c-secondary-500 td-none hover:td-underline mt-3 px-6 flex"
                                >
                                    <span className="pr-1 fs-14 fw-600"> {langTranslate('Know more')}</span>
                                </a>
                            </div>
                        ))}
                    </AwesomeSlider>
                </div>
                </>
            )}
        </>
    )
}

export default HomeOffer
